import { render, staticRenderFns } from "./SearchDetails.vue?vue&type=template&id=d52a0e4c&scoped=true&"
import script from "./SearchDetails.vue?vue&type=script&lang=js&"
export * from "./SearchDetails.vue?vue&type=script&lang=js&"
import style0 from "./SearchDetails.vue?vue&type=style&index=0&id=d52a0e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52a0e4c",
  null
  
)

export default component.exports